import type { AppCurrency, AppLanguage } from "./localePrefs";
import { intlLocaleForLanguage } from "./localePrefs";

export function formatMoney(
  amount: number,
  lang: AppLanguage,
  currency: AppCurrency,
): string {
  return new Intl.NumberFormat(intlLocaleForLanguage(lang), {
    style: "currency",
    currency,
  }).format(amount);
}

export function formatDate(
  input: string | Date | undefined,
  lang: AppLanguage,
): string {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) {
    return typeof input === "string" ? input : "—";
  }
  return d.toLocaleDateString(intlLocaleForLanguage(lang), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatTimeAgo(unixSeconds: number, nowMs = Date.now()): string {
  const diff = Math.max(0, Math.floor(nowMs / 1000) - unixSeconds);
  if (diff < 10) return "just now";
  if (diff < 60) return `${diff} second${diff === 1 ? "" : "s"} ago`;
  const minutes = Math.floor(diff / 60);
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }
  const hours = Math.floor(diff / 3600);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(diff / 86400);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
  const years = Math.floor(days / 365);
  return `${years} year${years === 1 ? "" : "s"} ago`;
}
